<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <OsLogsList />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import OsLogsList from '@/components/settings/consults/osLogs/List'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'OsLogsLists',
  components: {
    PageTitle,
    PageRowWrapper,
    OsLogsList,
    LoadingPage
  }
}
</script>